/**
 * Centralized copy for guest (not-logged-in) auth call-to-actions.
 *
 * Keeping every label here means a wording change happens in ONE place instead
 * of being hunted across the lobby header, table header, modal, join button,
 * and tournament modal.
 */
export const GUEST_CTA = {
  /** Lobby / table / multi-table header button. */
  header: 'Login or Sign up',
  /** Take a seat at a cash table — matches `waitlist` so the guest join-table
   *  and join-waitlist CTAs read identically. */
  cash: 'Login or Sign up to join',
  /** Join a Sit & Go. */
  sng: 'Login or Sign up to Join',
  /** Register for a multi-table tournament. */
  mtt: 'Login or Sign up to Register',
  /** Join a full cash table's waitlist. */
  waitlist: 'Login or Sign up to join'
} as const;
